// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OUX2","newExpiryDate":"styles_newExpiryDate__3egkf","footer":"styles_footer__2Yysr"};